import { createFileRoute } from '@tanstack/react-router';
import { Outlet } from '@/lib/router-components';

export const Route = createFileRoute('/client')({
  component: ClientLayoutRoute,
});

function ClientLayoutRoute() {
  return <Outlet />;
}

